import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { LazyLoaderModule } from "@obg/common.lazy-loader";
import { MatCoreModule } from "@obg/mat.ui.core";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";
import { GlobalUiLazyImageModule } from "@obg/ngx.ui.global.lazy-image";

import { HomeWrapperContainer } from "./home-wrapper.container";

const DIRECTIVES: any[] = [HomeWrapperContainer];

@NgModule({
	imports: [
		CommonModule,
		CoreContentModule,
		CoreModule,
		CoreUiModule,
		MatCoreModule,
		RouterModule,
		GlobalUiLazyImageModule,
		LazyLoaderModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MatHomeWrapperModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...DIRECTIVES);
	}
}
